import { render } from "./CustomRadioButtonsPreviousTreatment.vue?vue&type=template&id=0277f4d0&scoped=true&ts=true"
import script from "./CustomRadioButtonsPreviousTreatment.vue?vue&type=script&lang=ts"
export * from "./CustomRadioButtonsPreviousTreatment.vue?vue&type=script&lang=ts"

import "./CustomRadioButtonsPreviousTreatment.vue?vue&type=style&index=0&id=0277f4d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0277f4d0"]])

export default __exports__